import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import ComplianceResconConsignmentIdNotInPreconReport from '../components/ComplianceResconConsignmentIdNotInPreconReport';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/ComplianceResconConsignmentIdNotInPreconSummarySelectors';

export function ComplianceResconConsignmentIdNotInPreconSummaryContainer(props) {
  return (
    <ComplianceResconConsignmentIdNotInPreconReport
      reportId={ReportDefinitions.RESCON_CONSIGNMENT_ID_NOT_IN_PRECON_SUMMARY.id}
      columns={props.columns}
      isLoading={props.isLoading}
      generatedOnDateTime={props.generatedDateTime}
      data={props.data}
    />
  );
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    columns: getColumns(state),
  };
}

ComplianceResconConsignmentIdNotInPreconSummaryContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(ComplianceResconConsignmentIdNotInPreconSummaryContainer);
